/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entryfreenote2Inputs */

const en_entryfreenote2 = /** @type {(inputs: Entryfreenote2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests come without a ticket or sign-up.`)
};

const de_entryfreenote2 = /** @type {(inputs: Entryfreenote2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gäste kommen ohne Ticket und ohne Anmeldung.`)
};

/**
* | output |
* | --- |
* | "Guests come without a ticket or sign-up." |
*
* @param {Entryfreenote2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entryfreenote2 = /** @type {((inputs?: Entryfreenote2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entryfreenote2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entryfreenote2(inputs)
	return de_entryfreenote2(inputs)
});
export { entryfreenote2 as "entryFreeNote" }